module.exports = __webpack_public_path__ + "media/images/flags/kh-c982d1e5cf833f20088dfc51bf1c7b48.svg";